import type { IconData } from '@stacksjs/iconify-core'

export const doubleQuoteSansLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M232 246.857V16H16v400h38.4ZM48 48h152v185.143L48 377.905Zm232 368h38.4L496 246.857V16H280Zm32-368h152v185.143L312 377.905Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default doubleQuoteSansLeft
